
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Phí Điện, Nước Mặc Định Cho Căn Hộ Dịch Vụ</h3>
      </div>
      <div class="box-body">
        <div class="row">
            <div class="col-xs-4">
                <div class="form-group">
                    <label>Phí Điện</label>
                    <input type="text" class="form-control" :placeholder="'Nhập Phí Điện'" v-model="electric_fee" @change="formatElectricFee" v-on:keyup="formatElectricFee">
                </div>
            </div>
            <div class="col-xs-4">
                <div class="form-group">
                    <label>Phí Nước</label>
                    <input type="text" class="form-control" :placeholder="'Nhập Phí Nước'" v-model="water_fee" @change="formatWaterFee" v-on:keyup="formatWaterFee">
                </div>
            </div>
        </div>
      </div>
      <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            style="margin-right: 5px;"
            @click="saveServiceDefaultValue()"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.save')}}
          </button>
        </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils'

export default {
  name: "ProjectServiceDefaultFee",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      isLoading: false,
      water_fee: 0,
      electric_fee: 0,
      projectId: 0
    }
  },
  watch: {
    item: function() {
      this.initialize()
    },
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
        "GET_SNACK_BAR",
        "ERROR_TOAST",
        "SUCCESS_TOAST",
        "SET_SERVICE_DEFAULT_FEE_PROJECT"
    ]),
    formatElectricFee: function() {
      let array_electric_fee = []
      array_electric_fee.push(utils.formatInteger(this.electric_fee.toString()))
      this.electric_fee = utils.formatNumber(array_electric_fee[array_electric_fee.length - 1])
    },
    formatWaterFee: function() {
      let array_water_fee = []
      array_water_fee.push(utils.formatInteger(this.water_fee.toString()))
      this.water_fee = utils.formatNumber(array_water_fee[array_water_fee.length - 1])
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    initialize: function() {
      this.water_fee = !utils.isNull(this.item.water_fee) ? utils.formatNumber(this.item.water_fee) : 0
      this.electric_fee = !utils.isNull(this.item.electric_fee) ? utils.formatNumber(this.item.electric_fee) : 0
    },
    saveServiceDefaultValue: function() {
        let data = {
          water_fee: utils.formatInteger(this.water_fee.toString()),
          electric_fee: utils.formatInteger(this.electric_fee.toString()),
        }
        this.SET_SERVICE_DEFAULT_FEE_PROJECT({id: utils.getProjectSession(), ...data}).then(
          function(res) {
            this.SUCCESS_TOAST()
          }.bind(this)
        )
    }
  },
  mounted() {
  },
  components: {
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Project/ProjectServiceDefaultFee.vue